// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sglY","field":"styles_field__35vZJ","fieldCol":"styles_fieldCol__2xZia","diffCol":"styles_diffCol__3rhW2","diff":"styles_diff__13r-m"};